var map = {
	"./cola1.jpeg": 5266,
	"./cola3.jpeg": 5688,
	"./cola4.jpeg": 605,
	"./cola5.jpeg": 9286,
	"./orange1.jpeg": 8611,
	"./orange2.jpeg": 6278,
	"./product1.jpeg": 3792,
	"./product10.jpeg": 7056,
	"./product11.jpeg": 2839,
	"./product12.jpeg": 906,
	"./product13.jpeg": 4401,
	"./product14.jpeg": 9556,
	"./product15.jpeg": 715,
	"./product16.jpeg": 3006,
	"./product17.jpeg": 5493,
	"./product18.jpeg": 5336,
	"./product19.jpeg": 5823,
	"./product2.jpeg": 1457,
	"./product20.jpeg": 5647,
	"./product21.jpeg": 8232,
	"./product22.jpeg": 7897,
	"./product3.jpeg": 7706,
	"./product4.jpeg": 4075,
	"./product5.jpeg": 1332,
	"./product6.jpeg": 1605,
	"./product7.jpeg": 846,
	"./product8.jpeg": 8111,
	"./product9.jpeg": 9864,
	"./revuele1.jpeg": 1041,
	"./revuele2.jpeg": 2416,
	"./zarea.jpeg": 985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9749;